import { render } from "./sectionTitle.vue?vue&type=template&id=77d3015a&scoped=true"
import script from "./sectionTitle.vue?vue&type=script&lang=js"
export * from "./sectionTitle.vue?vue&type=script&lang=js"

import "./sectionTitle.vue?vue&type=style&index=0&id=77d3015a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\me\\OneDrive\\桌面\\HTML\\graduate_project_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d3015a"]])

export default __exports__